import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { color } from '../../../visual-analytics/helpers/colors';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { copyETLDryRunObjectTableColumns, ETLDryRunObjectTableAddColumn } from '../utils';
import { VALTYPES } from '../../../../data/interfaces';
import { addDryRunObjectTable, getETLComponentInputObjectTable } from '../../utils';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const inputTableObj = getETLComponentInputObjectTable(dryRun, comp, 'sourceTable');
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  // getETLComponentInputObject(dryRun, comp, )
  copyETLDryRunObjectTableColumns(inputTableObj, outputTableObj);
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'citations',
    'Citations',
    'The number of citations for the publication fetched from Europe PMC',
    VALTYPES.NUMBER,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'jcr_journal_impact_factor',
    'Journal Impact Factor',
    'The impact factor of the journal',
    VALTYPES.NUMBER,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'scimago_journal_rank',
    'Scimago Journal Rank',
    'The Scimago Journal Rank of the journal',
    VALTYPES.NUMBER,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'credibility',
    'Credibility',
    'The credibility of the publication',
    VALTYPES.NUMBER,
  );

  return {
    abort: false,
  };
}

export const manifestETLPublicationCredibility: TpETLComponentTypeManifest = {
  id: 'PublicationCredibility',
  name: 'Publication Credibility',
  description: 'Get journal impact factor, Scimago ranking info and the credibility of the publication',
  categoryId: 'publications',
  color: color(140, 0, 230),
  icon: <FontAwesomeIcon icon={['fas', 'ranking-star']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the clustered articles',
      columns: [],
    },
  ],
  params: [],
  performDryRun,
};
